<template>
    <div>
        <v-row>
            <v-col cols="12">
                <h3>Teste de Consumo Soluções:</h3>
            </v-col>
        </v-row>
        
        <v-toolbar id="solution-list" flat class="rounded-lg">
            <v-toolbar-title>Locais</v-toolbar-title>
            <v-spacer></v-spacer>
            
            <!-- Indicador de soluções modificadas -->
            <v-chip
                v-if="modifiedSolutionsCount > 0"
                color="warning"
                dark
                small
                class="mr-2"
            >
                <v-icon left small>mdi-pencil</v-icon>
                {{ modifiedSolutionsCount }} modificada(s)
            </v-chip>
            
            <!-- Botão para alternar visualização -->
            <v-btn
                color="primary"
                class="mb-2 mr-2"
                text
                @click="toggleViewMode"
                :title="viewMode === 'grouped' ? 'Ver como lista' : 'Ver agrupado'"
            >
                <v-icon left>{{ viewMode === 'grouped' ? 'mdi-view-list' : 'mdi-view-module' }}</v-icon>
                {{ viewMode === 'grouped' ? 'Lista' : 'Agrupado' }}
            </v-btn>
            
            <!-- Botão para abrir KPIs -->
            <v-btn
                color="primary"
                class="mb-2 mr-2"
                text
                @click="kpisDialog = true"
            >
                <v-icon left>mdi-chart-box</v-icon>
                KPIs
            </v-btn>
            
            <!-- Botão para criar locais padrões -->
            <v-btn
                color="primary"
                class="mb-2 mr-2"
                text
                @click="bulkCreateDialog = true"
            >
                <v-icon left>mdi-content-copy</v-icon>
                Locais Padrões
            </v-btn>
            
            <v-btn
                :color="selectedItems.length === 0 ? 'grey' : 'primary'"
                class="mb-2"
                text
                :disabled="selectedItems.length === 0"
                @click="deleteLot"
            >
                <v-icon color="primary" small>mdi-delete</v-icon>
            </v-btn>

            <v-btn
                color="primary"
                class="mb-2"
                text
                @click="() => create()"
            >
                <v-icon>add</v-icon>
            </v-btn>
        </v-toolbar>

        <!-- Modal de KPIs -->
        <v-dialog v-model="kpisDialog" max-width="900px" scrollable>
            <v-card>
                <v-card-title class="primary white--text">
                    <v-icon left color="white">mdi-chart-box</v-icon>
                    KPIs de Soluções
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="kpisDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pa-4">
                    <!-- Resumo Geral -->
                    <v-card elevation="2" color="primary" dark class="mb-6">
                        <v-card-title>
                            <v-icon left>mdi-chart-line</v-icon>
                            Resumo Geral
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <div class="text-caption">Economia Média Total</div>
                                    <div class="text-h5 font-weight-bold">{{ overallKpis.averageEconomy }}%</div>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <div class="text-caption">Total de Unidades</div>
                                    <div class="text-h5 font-weight-bold">{{ overallKpis.totalUnits }}</div>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <div class="text-caption">Total de Soluções</div>
                                    <div class="text-h5 font-weight-bold">{{ overallKpis.totalSolutions }}</div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    
                    <!-- KPIs por Tipo -->
                    <div v-for="(typeKpi, typeName) in kpisByType" :key="typeName" class="mb-6">
                        <v-card elevation="2" class="mb-3">
                            <v-card-title class="primary--text">
                                <v-icon left color="primary">mdi-water</v-icon>
                                {{ typeName }}
                                <v-spacer></v-spacer>
                                <v-chip color="info" dark small>
                                    {{ typeKpi.totalUnits }} unidade(s)
                                </v-chip>
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-card color="primary" dark>
                                            <v-card-text>
                                                <div class="text-caption">Economia Média</div>
                                                <div class="text-h4 font-weight-bold">{{ typeKpi.averageEconomy }}%</div>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-card color="success" dark>
                                            <v-card-text>
                                                <div class="text-caption">Total de Unidades</div>
                                                <div class="text-h4 font-weight-bold">{{ typeKpi.totalUnits }}</div>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                
                                <!-- KPIs por Solução dentro do Tipo -->
                                <v-divider class="my-4"></v-divider>
                                <div class="text-subtitle-1 mb-3">Por Solução:</div>
                                <v-row>
                                    <v-col 
                                        v-for="(solutionKpi, solutionName) in typeKpi.solutions" 
                                        :key="solutionName"
                                        cols="12" sm="6" md="4"
                                    >
                                        <v-card elevation="1" class="pa-3">
                                            <div class="text-body-1 font-weight-bold mb-2">{{ solutionName }}</div>
                                            <v-row dense>
                                                <v-col cols="6">
                                                    <div class="text-caption grey--text">Unidades</div>
                                                    <div class="text-h6">{{ solutionKpi.totalUnits }}</div>
                                                </v-col>
                                                <v-col cols="6">
                                                    <div class="text-caption grey--text">Economia Média</div>
                                                    <div class="text-h6">{{ solutionKpi.averageEconomy }}%</div>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="kpisDialog = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal de multiplicador por local -->
        <v-dialog v-model="localMultiplierDialog" max-width="400px">
            <v-card>
                <v-card-title class="primary white--text">
                    <v-icon left color="white">mdi-account-multiple</v-icon>
                    Unidades iguais do local
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="localMultiplierDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pt-4">
                    <div class="mb-2 font-weight-medium">
                        Local selecionado: <b>{{ localMultiplierForm.localName }}</b>
                    </div>
                    <div class="text-body-2 mb-2">
                        Informe o <b>total de unidades iguais</b> a este local, <b>incluindo a unidade que você está testando agora</b>.
                    </div>
                    <div class="text-body-2 mb-4 grey--text text--darken-1">
                        Exemplo: se este local representa um apartamento e o prédio possui
                        <b>20 apartamentos idênticos</b>, onde você só irá testar <b>1</b> deles,
                        informe <b>20</b>. Assim, os KPIs e relatórios vão considerar 1 unidade testada
                        e 19 unidades projetadas iguais a ela.
                    </div>
                    <v-form v-model="localMultiplierFormValid" ref="localMultiplierFormRef">
                        <v-text-field
                            v-model.number="localMultiplierForm.totalUnits"
                            label="Total de unidades iguais"
                            type="number"
                            min="1"
                            outlined
                            dense
                            :rules="[v => !!v || 'Obrigatório', v => Number(v) >= 1 || 'Mínimo 1']"
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="localMultiplierDialog = false">Cancelar</v-btn>
                    <v-btn color="primary" text @click="saveLocalMultiplier">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Botões Flutuantes -->
        <div id="itemAnimado" class="item-escondido" style="
                position: fixed;
                right: 20px;
                bottom: 70px;
                z-index: 2000;
            ">
            <div style="
                    background-color: rgb(25, 118, 210);
                    border-radius: 5px;
                    box-shadow: rgba(0, 0, 0, 0.8) 5px 5px 10px 2px;
                    height: 60px;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    padding: 6px;
                ">
                <v-btn 
                    @click="() => create()" 
                    v-if="showAddButton" 
                    style="margin: 0px 5px; color: white;"
                    icon
                >
                    <v-icon color="white">mdi-plus</v-icon>
                </v-btn>

                <v-btn 
                    @click="deleteLot" 
                    v-if="showDeleteButton" 
                    :disabled="selectedItems.length === 0"
                    style="margin: 0px 5px; color: white;"
                    icon
                >
                    <v-icon color="white">mdi-delete</v-icon>
                </v-btn>
            </div>
        </div>

        <!-- Controles de Expansão Global -->
        <div v-if="viewMode === 'grouped'" style="display: flex; padding: 0 20px; gap: 20px;">
            <div style="flex: 1; display: flex;">
                <div style="display: flex; justify-content: center; align-items: center; margin-right: 10px;">
                    <v-icon style="font-size: 30px;">mdi-arrow-expand-all</v-icon>
                </div>
                <div>
                    <v-switch v-model="expand_all" :label="`Expandir todos locais`"
                        @change="(status) => expandAll(status)"></v-switch>
                </div>
            </div>
            <div style="flex: 1; display: flex;">
                <div style="display: flex; justify-content: center; align-items: center; margin-right: 10px;">
                    <v-icon style="font-size: 30px;">mdi-checkbox-multiple-marked</v-icon>
                </div>
                <div>
                    <v-switch 
                        v-model="selectAllGlobal" 
                        :label="`Selecionar todas soluções`"
                        @change="(status) => toggleSelectAllGlobal(status)"
                    ></v-switch>
                </div>
            </div>
        </div>


        <!-- Filtro de Locais -->
        <v-container fluid v-if="viewMode === 'grouped'">
            <v-row align="center">
                <v-col cols="12">
                    <v-autocomplete 
                        v-model="values_locals" 
                        :items="locals" 
                        outlined 
                        dense 
                        chips 
                        small-chips
                        label="Local" 
                        multiple
                    ></v-autocomplete>
                </v-col>
            </v-row>
        </v-container>

        <!-- Filtro de Locais - Modo Lista -->
        <v-container fluid v-if="viewMode === 'list'">
            <v-row align="center">
                <v-col cols="12" md="6">
                    <v-autocomplete 
                        v-model="values_locals" 
                        :items="locals" 
                        outlined 
                        dense 
                        chips 
                        small-chips
                        label="Local" 
                        multiple
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                    <v-autocomplete 
                        v-model="values_sub_locals_list" 
                        :items="allSubLocals" 
                        outlined 
                        dense 
                        chips 
                        small-chips
                        label="Sub Local" 
                        multiple
                    ></v-autocomplete>
                </v-col>
            </v-row>
        </v-container>

        <!-- Layout Agrupado -->
        <v-row v-if="viewMode === 'grouped'">
            <v-expansion-panels v-model="localPanels" multiple>
                <v-expansion-panel 
                    v-for="({ local, isViewLocal, sub_locals }, i) in groupedList" 
                    :key="i"
                    style="background-color: rgba(0, 0, 0, .05);"
                >
                    <v-expansion-panel-header v-if="isViewLocal">
                        <div style="display: flex; align-items: center; width: 100%;">
                            <div style="flex: 1; display: flex; align-items: center;">
                                <b>{{ local }}</b>
                                <v-chip
                                    v-if="getModifiedCountByLocal(local) > 0"
                                    color="warning"
                                    dark
                                    x-small
                                    class="ml-2"
                                >
                                    <v-icon left x-small>mdi-pencil</v-icon>
                                    {{ getModifiedCountByLocal(local) }} modificada(s)
                                </v-chip>
                            </div>
                            
                            <!-- Indicador e ação de multiplicador por local -->
                            <v-chip
                                small
                                class="mr-2"
                                color="primary"
                                text-color="white"
                                @click.stop="openLocalMultiplierDialog(local)"
                            >
                                <v-icon left x-small>mdi-account-multiple</v-icon>
                                {{ getLocalMultiplier(local) }} unidade(s)
                            </v-chip>
                            
                            <v-btn
                                icon
                                small
                                @click.stop="openLocalMultiplierDialog(local)"
                                :title="`Definir número de unidades iguais para ${local}`"
                            >
                                <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content v-if="isViewLocal">
                        <!-- Controles de Expansão de Sub-locais -->
                        <div style="display: flex; padding: 0 20px;">
                            <div style="flex: 1; display: flex;">
                                <div style="display: flex; justify-content: center; align-items: center; margin-right: 10px;">
                                    <v-icon style="font-size: 40px;">mdi-arrow-expand-all</v-icon>
                                </div>
                                <div>
                                    <v-switch 
                                        v-model="sublocal_expand_all[i]" 
                                        :label="`Expandir todos sublocais`"
                                        @change="(status) => expandAllSublocals(i, status)"
                                    ></v-switch>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Filtro de Sub-locais -->
                        <v-container fluid>
                            <v-row align="center">
                                <v-col cols="12">
                                    <v-autocomplete 
                                        v-model="values_sub_locals_by_local[local]"
                                        :items="sub_locals_by_local[local]" 
                                        outlined 
                                        dense 
                                        chips 
                                        small-chips
                                        label="Sub Locais" 
                                        multiple
                                        @change="() => changeSubLocal(local)"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-container>

                        <!-- Sub-locais -->
                        <v-row justify="center">
                            <v-expansion-panels v-model="sublocalPanels[i]" multiple>
                                <v-expansion-panel 
                                    v-for="({ sub_local, isViewSublocal, items }, j) in sub_locals"
                                    :key="j"
                                >
                                    <v-expansion-panel-header v-if="isViewSublocal">
                                        <div style="display: flex; align-items: center; width: 100%;">
                                            <b style="flex: 1;">{{ sub_local }}</b>
                                            <v-chip
                                                v-if="getModifiedCountBySublocal(local, sub_local) > 0"
                                                color="warning"
                                                dark
                                                x-small
                                                class="ml-2"
                                            >
                                                <v-icon left x-small>mdi-pencil</v-icon>
                                                {{ getModifiedCountBySublocal(local, sub_local) }} modificada(s)
                                            </v-chip>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content v-if="isViewSublocal">
                                        <!-- Tabela de Soluções -->
                                        <v-data-table 
                                            :headers="headers" 
                                            :items="items" 
                                            class="elevation-1"
                                            style="width: 100%" 
                                            :items-per-page="-1"
                                        >
                                            <template v-slot:header.select>
                                                <input
                                                    type="checkbox"
                                                    :checked="allSelectedInGroup(items)"
                                                    :indeterminate.prop="someSelectedInGroup(items) && !allSelectedInGroup(items)"
                                                    @change="toggleSelectAllInGroup(items)"
                                                    class="checkbox-large"
                                                />
                                            </template>
                                            <template v-slot:body="{ items }">
                                                <tbody>
                                                    <tr v-for="(item, index) in items" :key="index">
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                :checked="selectedItems.includes(item)"
                                                                @change="toggleItemSelection(item)"
                                                                class="checkbox-large"
                                                            />
                                                        </td>
                                                        <td>{{ item.local }}</td>
                                                        <td>{{ item.sub_local }}</td>
                                                        <td>{{ convertNameType(item.type) }}</td>
                                                        <td>{{ convertSolutionName(item.solution) }}</td>
                                                        <td>{{ item.amountSolution }}</td>
                                                        <td>{{ item.flowRateBefore + " / " + item.flowRateAfter }}</td>
                                                        <td>{{ item.economy }}%</td>
                                                        <td>{{ item.comments || '-' }}</td>
                                                        <td>
                                                            <v-chip
                                                                v-if="item.isModified"
                                                                color="warning"
                                                                dark
                                                                x-small
                                                                class="ma-0"
                                                            >
                                                                <v-icon left x-small>mdi-pencil</v-icon>
                                                                Modificada
                                                            </v-chip>
                                                            <v-chip
                                                                v-else
                                                                color="success"
                                                                dark
                                                                x-small
                                                                class="ma-0"
                                                            >
                                                                <v-icon left x-small>mdi-check</v-icon>
                                                                OK
                                                            </v-chip>
                                                        </td>
                                                        <td>
                                                            <v-row>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-icon
                                                                            v-bind="attrs"
                                                                            v-on="on"
                                                                            :color="hasBeforeImage(item) ? 'primary' : 'default'"
                                                                            class="mr-2">
                                                                            mdi-image
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>{{ hasBeforeImage(item) ? 'Imagem Antes' : 'Sem Imagem Antes' }}</span>
                                                                </v-tooltip>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-icon
                                                                            v-bind="attrs"
                                                                            v-on="on"
                                                                            :color="hasAfterImage(item) ? 'primary' : 'default'">
                                                                            mdi-image
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>{{ hasAfterImage(item) ? 'Imagem Depois' : 'Sem Imagem Depois' }}</span>
                                                                </v-tooltip>
                                                            </v-row>
                                                        </td>
                                                        <td>
                                                            <v-row style="align-items: center;">
                                                                <v-btn
                                                                    elevation="2"
                                                                    :loading="loadingForAction('delete') && loadingForActions.index === calculatedIndex(item)"
                                                                    :disabled="isDisabled('delete', item)"
                                                                    @click.stop="confirmDeleteSolution(item)"
                                                                    style="height: 30px; margin: 2px"
                                                                >
                                                                    <v-icon color="error" small>mdi-delete</v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    elevation="2"
                                                                    :loading="loadingForAction('edit') && loadingForActions.index === calculatedIndex(item)"
                                                                    :disabled="isDisabled('edit', item)"
                                                                    @click.stop="edit(item)"
                                                                    style="height: 30px; margin: 2px"
                                                                >
                                                                    <v-icon color="primary" small>mdi-pencil</v-icon>
                                                                </v-btn>
                                                            </v-row>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-data-table>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-row>

        <!-- Layout em Lista -->
        <v-row v-if="viewMode === 'list'">
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="filteredListForTable"
                    :items-per-page="15"
                    class="elevation-1"
                    :sort-by="['local', 'sub_local']"
                    :sort-desc="[false, false]"
                    multi-sort
                >
                    <template v-slot:header.select>
                        <input
                            type="checkbox"
                            :checked="allSelected"
                            :indeterminate.prop="someSelected && !allSelected"
                            @change="toggleSelectAll"
                            class="checkbox-large"
                        />
                    </template>
                    <template v-slot:item.select="{ item }">
                        <input
                            type="checkbox"
                            :checked="selectedItems.includes(item)"
                            @change="toggleItemSelection(item)"
                            class="checkbox-large"
                        />
                    </template>
                    <template v-slot:item.local="{ item }">
                        {{ item.local }}
                    </template>
                    <template v-slot:item.sub_local="{ item }">
                        {{ item.sub_local }}
                    </template>
                    <template v-slot:item.type="{ item }">
                        {{ convertNameType(item.type) }}
                    </template>
                    <template v-slot:item.solution="{ item }">
                        {{ convertSolutionName(item.solution) }}
                    </template>
                    <template v-slot:item.amountSolution="{ item }">
                        {{ item.amountSolution }}
                    </template>
                    <template v-slot:item.flowRateBefore="{ item }">
                        {{ item.flowRateBefore + " / " + item.flowRateAfter }}
                    </template>
                    <template v-slot:item.economy="{ item }">
                        {{ item.economy }}%
                    </template>
                    <template v-slot:item.comments="{ item }">
                        {{ item.comments || '-' }}
                    </template>
                    <template v-slot:item.status="{ item }">
                        <v-chip
                            v-if="item.isModified"
                            color="warning"
                            dark
                            x-small
                            class="ma-0"
                        >
                            <v-icon left x-small>mdi-pencil</v-icon>
                            Modificada
                        </v-chip>
                        <v-chip
                            v-else
                            color="success"
                            dark
                            x-small
                            class="ma-0"
                        >
                            <v-icon left x-small>mdi-check</v-icon>
                            OK
                        </v-chip>
                    </template>
                    <template v-slot:item.Img="{ item }">
                        <v-row>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        :color="hasBeforeImage(item) ? 'primary' : 'default'"
                                        class="mr-2">
                                        mdi-image
                                    </v-icon>
                                </template>
                                <span>{{ hasBeforeImage(item) ? 'Imagem Antes' : 'Sem Imagem Antes' }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        :color="hasAfterImage(item) ? 'primary' : 'default'">
                                        mdi-image
                                    </v-icon>
                                </template>
                                <span>{{ hasAfterImage(item) ? 'Imagem Depois' : 'Sem Imagem Depois' }}</span>
                            </v-tooltip>
                        </v-row>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-row style="align-items: center;">
                            <v-btn
                                elevation="2"
                                :loading="loadingForAction('delete') && loadingForActions.index === calculatedIndex(item)"
                                :disabled="isDisabled('delete', item)"
                                @click.stop="confirmDeleteSolution(item)"
                                style="height: 30px; margin: 2px"
                            >
                                <v-icon color="error" small>mdi-delete</v-icon>
                            </v-btn>
                            <v-btn
                                elevation="2"
                                :loading="loadingForAction('edit') && loadingForActions.index === calculatedIndex(item)"
                                :disabled="isDisabled('edit', item)"
                                @click.stop="edit(item)"
                                style="height: 30px; margin: 2px"
                            >
                                <v-icon color="primary" small>mdi-pencil</v-icon>
                            </v-btn>
                        </v-row>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        
        <!-- Removendo a tabela antiga - mantendo apenas o dialog -->
        <v-row style="display: none;">
            <!-- Start Table Solutions -->
            <v-data-table
              multi-sort
              :headers="headers"
                :items="filteredSolutionList"
                class="elevation-1"
                style="width: 100%"
                :items-per-page="itemsPerPage"
                :show-select="false"
                :item-key="'id'"
                :custom-filter="() => true"  
            >


   
                <template v-slot:top>
                    <v-row>
                        <v-col cols="6" sm="2" style="background-color: #1976D250;
                            min-width: 150px;
                            border-color: #1976D2;
                            border-bottom: 5px solid #1976D2; 
                            border-radius: 5px;
                            margin-right: 10px;">
                            <span>Economia Média</span>
                            <h2>{{getAverageEconomy}}</h2>
                        </v-col>
                        <v-col cols="6" sm="2" style="background-color: #1976D250;
                            min-width: 150px;
                            border-color: #1976D2;
                            border-bottom: 5px solid #1976D2; 
                            border-radius: 5px;">
                            <span>Soluções</span>
                            <h2>{{getTotalSolutions}}</h2>
                        </v-col>
                    </v-row>
                    <v-toolbar flat class="rounded-lg">
                        <v-toolbar-title>Solução</v-toolbar-title>
                        <v-spacer></v-spacer>
                        
                        <!-- Indicador de soluções modificadas -->
                        <v-chip
                            v-if="modifiedSolutionsCount > 0"
                            color="warning"
                            dark
                            small
                            class="mr-2"
                        >
                            <v-icon left small>mdi-pencil</v-icon>
                            {{ modifiedSolutionsCount }} modificada(s)
                        </v-chip>
                        
                        <v-btn
                            :color="selectedItems.length === 0 ? 'grey' : 'primary'"
                            class="mb-2"
                            text
                            :disabled="selectedItems.length === 0"
                            @click="deleteLot"
                        >
                        <v-icon color="primary" small>mdi-delete</v-icon>
                        </v-btn>

                        <v-btn
                            color="primary"
                            class="mb-2"
                            text
                            @click="() => create()"
                        >
                            <v-icon>add</v-icon>
                        </v-btn>
                    </v-toolbar>
                </template>
                <template v-slot:header.select>
                  <input
                    type="checkbox"
                    :checked="allSelected"
                    :indeterminate.prop="someSelected && !allSelected"
                    @change="toggleSelectAll"
                    class="checkbox-large"
                  />
                </template>
                <template v-slot:item.type="{ item }">
                    {{ convertNameType(item.type) }}
                </template>
                <template v-slot:item.solution="{ item }">
                    {{ convertSolutionName(item.solution) }}
                </template>
                <template v-slot:item.flowRateBefore="{ item }">
                    {{ item.flowRateBefore + " /  " +  item.flowRateAfter}}
                </template>

                <template v-slot:item.status="{ item }">
                    <v-chip
                        v-if="item.isModified"
                        color="warning"
                        dark
                        x-small
                        class="ma-0"
                    >
                        <v-icon left x-small>mdi-pencil</v-icon>
                        Modificada
                    </v-chip>
                    <v-chip
                        v-else
                        color="success"
                        dark
                        x-small
                        class="ma-0"
                    >
                        <v-icon left x-small>mdi-check</v-icon>
                        OK
                    </v-chip>
                </template>

                <template v-slot:item.Img="{ item }">
                    <v-row>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    :color="hasBeforeImage(item) ? 'primary' : 'default'"
                                    class="mr-2">
                                    mdi-image
                                </v-icon>
                            </template>
                            <span>{{ hasBeforeImage(item) ? 'Imagem Antes' : 'Sem Imagem Antes' }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    :color="hasAfterImage(item) ? 'primary' : 'default'">
                                    mdi-image
                                </v-icon>
                            </template>
                            <span>{{ hasAfterImage(item) ? 'Imagem Depois' : 'Sem Imagem Depois' }}</span>
                        </v-tooltip>
                    </v-row>
                </template>

                <template v-slot:item.select="{ item }">
                  <input
                    type="checkbox"
                    :checked="selectedItems.includes(item)"
                    @change="toggleItemSelection(item)"
                    class="checkbox-large"
                  />
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-row style="align-items: center;">
                      <v-btn
                          elevation="2"
                          :disabled="isDisabled('edit', item)"
                          @click.stop="confirmDeleteSolution(item)"
                          style="height: 30px; margin: 2px"
                      >
                        <v-icon color="primary" small>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                          elevation="2"
                          :loading="loadingForAction('edit') && loadingForActions.index === calculatedIndex(item)"
                          :disabled="isDisabled('delete', item)"
                          @click="edit(item)"
                          style="height: 30px; margin: 2px"
                      >
                        <v-icon color="primary" small>mdi-pencil</v-icon>
                      </v-btn>
                    </v-row>
                </template>


            </v-data-table>
            <!-- End Table Solutions -->
        </v-row>
        <v-dialog 
            transition="dialog-top-transition" 
            v-model="dialog" 
            persistent max-width="700px"
        >
            <v-card>
                <v-toolbar color="primary" dark> <span class="text-h5">Adicionar Solução</span></v-toolbar>
                <v-card-title>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text style="padding-bottom: 0px;">
                    <v-row>
                        <h3> Informações do Ponto</h3>
                    </v-row>
                    <v-form  ref="testSolutionForm" v-model="validForm" lazy-validation>
                        <v-row>
                            <v-col cols="12" :sm="6">
                                <LocalField 
                                    :key="`local-${solution.local || 'new'}`"
                                    :proposal="{ solutionList: solutionList }"
                                    :id="solution.local"
                                    :loading="loading"
                                    :disabled="loading"
                                    @change:input="(value) => changeLocal(value)"
                                />
                            </v-col>
                            <v-col cols="12" :sm="6">
                                <SublocalField 
                                    :key="`sublocal-${solution.sub_local || 'new'}`"
                                    :proposal="{ solutionList: solutionList }"
                                    :id="solution.sub_local"
                                    :loading="loading"
                                    :disabled="loading"
                                    @change:input="(value) => changeSublocal(value)"
                                />
                            </v-col>
                            <v-col cols="12" :sm="solution.pipingType ? 6 : 4">
                                <v-autocomplete 
                                    label="Tipo" 
                                    :items="pointsData" 
                                    item-text="name"
                                    item-value="id" 
                                    outlined 
                                    v-model="solution.type"
                                    @change="optionTypeSelect(solution.type)" 
                                    :rules="rulesRequired" 
                                    onfocus
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col v-if="solution.pipingType" cols="12" :sm="solution.pipingType ? 6 : 4">
                                <v-select
                                    :items="pipingTypesList"
                                    v-model="solution.pipingType"
                                    label="Tipo da Tubulação"
                                    outlined
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col cols="12" :sm="solution.pipingType ? 6 : 4">
                                <v-autocomplete label="Soluções" 
                                    :items="solutionsOptionsList" 
                                    v-model="solution.solution" 
                                    outlined
                                    item-text="solution"
                                    item-value="id"
                                    :rules="rulesRequired"
                                    :disabled="loading || solution.type === null"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col cols="12" :sm="solution.pipingType ? 6 : 4">
                                <NumberInput 
                                    v-model="solution.amountSolution" 
                                    :label="'Qtnd.'"
                                    :suffix="''"
                                    outlined
                                    required
                                    :rules="rulesRequired"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" :sm="4">
                                <NumberInput
                                    v-model="solution.flowRateBefore"
                                    :label="'Vazão antes'"
                                    :suffix="'L/min'"
                                    outlined
                                    :isFloat="true"
                                    :rules="rulesRequired"
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col cols="12" :sm="4">
                                <NumberInput
                                    v-model="solution.flowRateAfter" 
                                    :label="'Vazão Depois'"
                                    :suffix="'L/min'"
                                    outlined
                                    :isFloat="true"
                                    :rules="rulesRequired"
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col cols="12" :sm="4">
                                <v-select
                                    :items="flowTypeList"
                                    v-model="solution.flowRateType"
                                    label="Tipo do fluxo"
                                    outlined
                                    :rules="rulesRequired"
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field 
                                    v-model="solution.economy" 
                                    outlined 
                                    label="Economia" 
                                    readonly 
                                    suffix="%"
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col cols="12" :sm="12">
                                <v-textarea 
                                    v-model="solution.comments" 
                                    outlined 
                                    label="Observação" 
                                    type="text"
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-row>
                        <v-col cols="6">
                            <InputFiles
                                title="Foto Antes"
                                :loading="loadingImage"
                                :fileTypes="['image']"
                                :showFile="solution.file_before_solution"
                                @change:file="(file) => handleImageChange('before', file)"
                            />
                        </v-col>
                        <v-col cols="6">
                            <InputFiles
                                title="Foto Depois"
                                :loading="loadingImage"
                                :fileTypes="['image']"
                                :showFile="solution.file_after_solution"
                                @change:file="(file) => handleImageChange('after', file)"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                        color="blue darken-1" 
                        text 
                        @click="() => closeDialog()"
                        :disabled="loading"
                        :loading="loading"
                    >Cancelar</v-btn>
                    <v-btn 
                        color="blue darken-1" 
                        text 
                        @click="() => save(false)"
                        :disabled="loading || !validForm"
                        :loading="loading"
                    >Adicionar e fechar</v-btn>
                    <v-btn 
                        color="blue darken-1" 
                        text 
                        @click="() => save(true)"
                        :disabled="loading || !validForm"
                        :loading="loading"
                        v-if="isAdd"
                    >Adicionar e continuar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal para criar locais padrões -->
        <v-dialog 
            v-model="bulkCreateDialog" 
            max-width="800px" 
            persistent
            scrollable
        >
            <v-card>
                <v-toolbar color="primary" dark>
                    <v-toolbar-title>
                        <v-icon left>mdi-content-copy</v-icon>
                        Criar Locais Padrões
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="bulkCreateDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-4">
                    <v-form ref="bulkCreateForm" v-model="bulkCreateValid">
                        <v-row>
                            <v-col cols="12">
                                <h3 class="mb-3">Estrutura dos Locais</h3>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="bulkCreateConfig.localName"
                                    label="Nome do Local (ex: Apartamento, Unidade)"
                                    outlined
                                    :rules="rulesRequired"
                                    hint="Ex: Apartamento, Unidade"
                                    persistent-hint
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <NumberInput
                                    v-model="bulkCreateConfig.localCount"
                                    label="Quantidade de Locais"
                                    outlined
                                    :rules="rulesRequired"
                                    hint="Ex: 10 (para 10 apartamentos)"
                                    persistent-hint
                                />
                            </v-col>
                        </v-row>

                        <v-divider class="my-4"></v-divider>

                        <v-row>
                            <v-col cols="12">
                                <h3 class="mb-3">Ambientes (Sub-locais) e Soluções</h3>
                                <p class="text-caption mb-3">Defina os ambientes e suas soluções para cada local</p>
                            </v-col>
                            <v-col cols="12">
                                <div v-for="(room, roomIndex) in bulkCreateConfig.rooms" :key="roomIndex" class="mb-4">
                                    <v-card outlined class="mb-2">
                                        <v-card-title class="primary white--text py-2">
                                            <v-icon left color="white">mdi-door</v-icon>
                                            Sub-local {{ roomIndex + 1 }}
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                icon
                                                dark
                                                small
                                                @click="removeRoom(roomIndex)"
                                                :disabled="bulkCreateConfig.rooms.length === 1"
                                            >
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row>
                                                <v-col cols="12" md="6">
                                                    <v-text-field
                                                        v-model="room.name"
                                                        label="Nome do Ambiente"
                                                        outlined
                                                        dense
                                                        hint="Ex: Banheiro Suíte, Banheiro Social, Cozinha"
                                                        persistent-hint
                                                        :rules="rulesRequired"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <NumberInput
                                                        v-model="room.quantity"
                                                        label="Quantidade"
                                                        outlined
                                                        dense
                                                        hint="Quantidade deste ambiente por local (apartamento, unidade, etc.)"
                                                        persistent-hint
                                                        :rules="rulesRequired"
                                                    />
                                                </v-col>
                                            </v-row>
                                            
                                            <v-divider class="my-3"></v-divider>
                                            
                                            <div class="mb-2">
                                                <strong>Soluções deste Ambiente:</strong>
                                            </div>
                                            
                                            <div v-for="(solution, solutionIndex) in room.solutions" :key="solutionIndex" class="mb-2" style="position: relative;">
                                                <v-card outlined color="grey lighten-4" style="position: relative;">
                                                    <!-- Botão de deletar no canto superior direito -->
                                                    <v-tooltip bottom v-if="room.solutions.length > 1">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn
                                                                icon
                                                                x-small
                                                                color="error"
                                                                absolute
                                                                top
                                                                right
                                                                style="margin: -12px; z-index: 10;"
                                                                @click="removeSolution(roomIndex, solutionIndex)"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >
                                                                <v-icon x-small>mdi-close</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Remover solução</span>
                                                    </v-tooltip>
                                                    <v-btn
                                                        v-else
                                                        icon
                                                        x-small
                                                        color="grey"
                                                        absolute
                                                        top
                                                        right
                                                        style="margin: -12px; z-index: 10;"
                                                        disabled
                                                    >
                                                        <v-icon x-small>mdi-close</v-icon>
                                                    </v-btn>
                                                    
                                                    <v-card-text class="py-2">
                                                        <v-row align="center">
                                                            <v-col cols="12" md="4">
                                                                <v-autocomplete
                                                                    v-model="solution.type"
                                                                    label="Tipo"
                                                                    :items="pointsData"
                                                                    item-text="name"
                                                                    item-value="id"
                                                                    outlined
                                                                    dense
                                                                    :rules="rulesRequired"
                                                                ></v-autocomplete>
                                                            </v-col>
                                                            <v-col cols="12" md="4">
                                                                <v-autocomplete
                                                                    v-model="solution.solution"
                                                                    label="Solução"
                                                                    :items="getSolutionsForType(solution.type)"
                                                                    item-text="solution"
                                                                    item-value="id"
                                                                    outlined
                                                                    dense
                                                                    :rules="rulesRequired"
                                                                    :disabled="!solution.type"
                                                                ></v-autocomplete>
                                                            </v-col>
                                                            <v-col cols="12" md="4">
                                                                <NumberInput
                                                                    v-model="solution.amount"
                                                                    label="Qtd"
                                                                    outlined
                                                                    dense
                                                                    :rules="rulesRequired"
                                                                />
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12" md="4">
                                                                <NumberInput
                                                                    v-model="solution.flowRateBefore"
                                                                    label="Vazão Antes"
                                                                    :suffix="'L/min'"
                                                                    outlined
                                                                    dense
                                                                    :isFloat="true"
                                                                />
                                                            </v-col>
                                                            <v-col cols="12" md="4">
                                                                <NumberInput
                                                                    v-model="solution.flowRateAfter"
                                                                    label="Vazão Depois"
                                                                    :suffix="'L/min'"
                                                                    outlined
                                                                    dense
                                                                    :isFloat="true"
                                                                />
                                                            </v-col>
                                                            <v-col cols="12" md="4">
                                                                <v-select
                                                                    v-model="solution.flowRateType"
                                                                    label="Tipo Fluxo"
                                                                    :items="flowTypeList"
                                                                    outlined
                                                                    dense
                                                                    :rules="rulesRequired"
                                                                ></v-select>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </div>
                                            
                                            <v-btn
                                                color="primary"
                                                outlined
                                                small
                                                @click="addSolution(roomIndex)"
                                                class="mt-2"
                                            >
                                                <v-icon left small>mdi-plus</v-icon>
                                                Adicionar Solução
                                            </v-btn>
                                        </v-card-text>
                                    </v-card>
                                </div>
                                <v-btn
                                    color="primary"
                                    outlined
                                    small
                                    @click="addRoom"
                                    class="mb-3"
                                >
                                    <v-icon left small>mdi-plus</v-icon>
                                    Adicionar Ambiente
                                </v-btn>
                            </v-col>
                        </v-row>

                        <v-alert
                            v-if="bulkCreatePreviewCount > 0"
                            type="info"
                            class="mt-4"
                        >
                            <strong>Preview:</strong> Serão criadas aproximadamente <strong>{{ bulkCreatePreviewCount }}</strong> soluções.
                        </v-alert>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        @click="bulkCreateDialog = false"
                        :disabled="bulkCreateLoading"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="generateBulkSolutions"
                        :loading="bulkCreateLoading"
                        :disabled="!bulkCreateValid || bulkCreateLoading"
                    >
                        <v-icon left>mdi-content-copy</v-icon>
                        Gerar Soluções
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
  
<script>
import InputFiles from "@/components/Forms/Input/input-files.vue";
import WaterScanStoragefrom from '@/services/storage/WaterScanStorage';
import { showDeleteDialogAlert } from "@/utils/DialogAlertHelper";
import { showSuccessSnackBar, showErrorSnackBar } from "@/utils/SnackBartHelper";
import SolutionsServices from '@/services/firebase/SolutionsServices/SolutionsServices';
import DiagnosticServiceFirebase from "@/services/firebase/Diagnostic/DiagnosticService";
import SolutionsPoint from '@/services/firebase/SolutionsPoint/SolutionsPoint';
import DiagnosticStorage from '@/services/storage/DiagnosticStorage';
import Rules from "@/utils/Rules";
import cloneDeep from 'lodash/cloneDeep';
import { mapGetters } from "vuex";
import NumberInput from "../../../../Inputs/NumberInput.vue";

import SolutionListModel from '@/objects/Waterscan/CheckListTab/SolutionListModel.js'
import VueHorizontal from 'vue-horizontal';
import Utils from '@/scripts/Utils';
import LocalField from './Fields/LocalField.vue';
import SublocalField from './Fields/SublocalField.vue';


const newSolution = () => {
    return {
        amountSolution: "",
        flowRateBefore: "",
        flowRateAfter: "",
        file_before_solution: null,
        file_after_solution: null,
        local: "",
        sub_local: "",
        solution: "",
        type: "",
        pipingType: "",
        flowRateType: "PROJETADA",
        // Quantidade total de unidades iguais associadas a este local
        // (inclui a unidade testada; padrão 1 = sem multiplicação)
        localTotalUnits: 1,
        economy: 0,
        comments: "",
        imgNameList: [],
        isModified: false,
    }
}

const PIPING_POINT_ID = "vIEqBb4EEnWAJU5HbYXs"

export default {
    name: "SolutionList",
    
    components: {
        VueHorizontal,
        NumberInput,
        InputFiles,
        LocalField,
        SublocalField
    },
    
    props: {
        list: {
            type: Array,
            default: () => ([]),
        },
        add: {
            type: Function,
            default: (solution, index) => {}
        },
        remove: {
            type: Function,
            default: (index) => {}
        },
        projectId: {
            type: String,
            default: null,
        },
    },
    
    data: () => ({
        solution: newSolution(),
        solutionList: [],
        dialog: false,
        index: -1,
        loading: false,
        loadingForActions: {},
        loadingImage: false,
        validForm: true,
        isAdd: true,
        headers: [
            { text: "", value: 'select', maxWidth: 50, sortable: false },
            { text: "Local", value: "local",  maxWidth: 130,sortable: true },
            { text: "Sub local", value: "sub_local", sortable: true },
            { text: "Tipo", value: "type", width: 130, sortable: true },
            { text: "Solução", value: "solution", width: 200, sortable: true },
            { text: "Quantidade", value: "amountSolution", width: 100, sortable: true },
            { text: "Vazão(L) Antes/Depois", value: "flowRateBefore", width: 130, sortable: true },
            { text: "Economia (%) ", value: "economy", sortable: true },
            { text: "Observação", value: "comments", sortable: true },
            { text: "Status", value: "status", width: 80, sortable: false },
            { text: "Img", value: "Img", sortable: false },
            { text: "Ações", value: "actions", sortable: false },
        ],
        optionsType: [
            { text: "Torneira", value: "faucet" },
            { text: "Chuveiro", value: "shower" },
            { text: "Descarga", value: "discharge" },
        ],
        pipingTypesList: SolutionListModel.getPipingTypeList(),
        flowTypeList: SolutionListModel.getFlowTypeList(),
        solutionsData: [],
        pointsData: [],

        listImgs: [],
        editedItem: {},
        deleteImgFile: {},
        rawFiles: [],
        itemsPerPage: 5,
        localList: [],
        selectedItems: [],
        // Propriedades para agrupamento
        groupedList: [],
        // Multiplicador lógico por local (para unidades iguais, sem duplicar itens fisicamente)
        // Estrutura: { [localKey]: number }
        localMultipliers: {},
        locals: [],
        values_locals: [],
        sub_locals_by_local: {},
        values_sub_locals_by_local: {},
        values_sub_locals_list: [], // Para filtro no modo lista
        localPanels: [],
        sublocalPanels: {},
        expand_all: false,
        sublocal_expand_all: {},
        solution_list_map: [],
        // Propriedades para botões flutuantes
        showAddButton: false,
        showDeleteButton: false,
        showCheckListButtons: false,
        interval: null,
        // Modal de KPIs
        kpisDialog: false,
        // Modo de visualização
        viewMode: 'grouped', // 'grouped' ou 'list'
        // Seleção global
        selectAllGlobal: false,
        // Modal de criação em massa
        bulkCreateDialog: false,
        bulkCreateValid: false,
        bulkCreateLoading: false,
        bulkCreateConfig: {
            localName: '',
            localCount: null,
            rooms: [
                { 
                    name: '', 
                    quantity: 1,
                    solutions: [
                        {
                            type: null,
                            solution: null,
                            amount: 1,
                            flowRateType: 'PROJETADA',
                            flowRateBefore: '',
                            flowRateAfter: ''
                        }
                    ]
                }
            ],
        },
        // Modal de multiplicador de unidades por local
        localMultiplierDialog: false,
        localMultiplierFormValid: false,
        localMultiplierForm: {
            localName: '',
            localKey: '',
            totalUnits: 1,
        },
    }),

    computed: {
        ...mapGetters([
            "getCurrentUser",
        ]),
        rulesRequired() {
            return Rules.required();
        },
        solutionsOptionsList() {
            return this.optionTypeSelect(this.solution.type)
        },
        getAverageEconomy() {
            if (this.filteredSolutionList.length ) {
                const totalConsumption = this.filteredSolutionList.reduce((sum, item) => sum + (item.economy * item.amountSolution), 0);
                return `${(totalConsumption / this.getTotalSolutions).toFixed(2)} %`
            }
            return 0
        },
        getTotalSolutions() {
            if (this.filteredSolutionList.length ) {
                const totalConsumption = this.filteredSolutionList.reduce((sum, item) => sum + Number(item.amountSolution), 0);
                return (totalConsumption)
            }
            return 0
        },
        isFranchisee(){
            return this.getCurrentUser.data.rank === "Franqueado"
        },
        allSelected() {
            return this.filteredSolutionList.length > 0 && this.selectedItems.length === this.filteredSolutionList.length;
        },
        someSelected() {
            return this.selectedItems.length > 0 && this.selectedItems.length < this.filteredSolutionList.length;
        },
        filteredSolutionList() {
            return this.solutionList.filter(item => item.isDeleted !== true);
        },
        filteredListForTable() {
            let filtered = this.filteredSolutionList;
            
            // Aplica filtro de locais
            if (this.values_locals && this.values_locals.length > 0) {
                filtered = filtered.filter(item => {
                    const sanitizedLocal = this.sanitizeName(item.local);
                    return this.values_locals.includes(sanitizedLocal);
                });
            }
            
            // Aplica filtro de sub-locais (modo lista)
            if (this.viewMode === 'list' && this.values_sub_locals_list && this.values_sub_locals_list.length > 0) {
                filtered = filtered.filter(item => {
                    const sanitizedSublocal = this.sanitizeName(item.sub_local);
                    return this.values_sub_locals_list.includes(sanitizedSublocal);
                });
            }
            
            // Aplica filtro de sub-locais por local (modo agrupado)
            if (this.viewMode === 'grouped' && this.values_sub_locals_by_local && Object.keys(this.values_sub_locals_by_local).length > 0) {
                filtered = filtered.filter(item => {
                    const sanitizedLocal = this.sanitizeName(item.local);
                    const subLocalsForLocal = this.values_sub_locals_by_local[sanitizedLocal];
                    
                    // Se não há filtro de sub-local para este local, mostra todos
                    if (!subLocalsForLocal || subLocalsForLocal.length === 0) {
                        // Verifica se há filtro para outros locais
                        const hasFilterForOtherLocals = Object.keys(this.values_sub_locals_by_local).some(local => {
                            const subLocals = this.values_sub_locals_by_local[local];
                            return subLocals && subLocals.length > 0;
                        });
                        
                        // Se há filtro para outros locais mas não para este, oculta este item
                        if (hasFilterForOtherLocals && !subLocalsForLocal) {
                            return false;
                        }
                        
                        return true;
                    }
                    
                    // Se há filtro de sub-local para este local, verifica se o sub-local está na lista
                    const sanitizedSublocal = this.sanitizeName(item.sub_local);
                    return subLocalsForLocal.includes(sanitizedSublocal);
                });
            }
            
            return filtered;
        },
        allSubLocals() {
            // Retorna todos os sub-locais únicos para o filtro no modo lista
            const subLocalsSet = new Set();
            this.filteredSolutionList.forEach(item => {
                if (item.sub_local) {
                    const sanitized = this.sanitizeName(item.sub_local);
                    subLocalsSet.add(sanitized);
                }
            });
            return Array.from(subLocalsSet).sort();
        },
        bulkCreatePreviewCount() {
            if (!this.bulkCreateConfig.localCount) {
                return 0;
            }
            let totalSolutions = 0;
            this.bulkCreateConfig.rooms.forEach(room => {
                const roomQuantity = Number(room.quantity) || 0;
                const solutionsInRoom = room.solutions ? room.solutions.length : 0;
                const solutionsAmount = room.solutions ? room.solutions.reduce((sum, sol) => {
                    return sum + (Number(sol.amount) || 0);
                }, 0) : 0;
                totalSolutions += roomQuantity * solutionsAmount;
            });
            return this.bulkCreateConfig.localCount * totalSolutions;
        },
        modifiedSolutionsCount() {
            return this.filteredSolutionList.filter(item => item.isModified).length;
        },
        kpisByType() {
            const kpis = {};
            
            this.filteredSolutionList.forEach(item => {
                const typeName = this.convertNameType(item.type);
                const solutionName = this.convertSolutionName(item.solution);
                const baseAmount = Number(item.amountSolution) || 0;
                const localMultiplier = this.getLocalMultiplier(item.local);
                const amount = baseAmount * localMultiplier;
                const economy = Number(item.economy) || 0;
                
                if (!kpis[typeName]) {
                    kpis[typeName] = {
                        totalUnits: 0,
                        totalEconomy: 0,
                        totalEconomyWeighted: 0,
                        solutions: {}
                    };
                }
                
                // Atualizar totais do tipo
                kpis[typeName].totalUnits += amount;
                kpis[typeName].totalEconomyWeighted += economy * amount;
                
                // Atualizar por solução
                if (!kpis[typeName].solutions[solutionName]) {
                    kpis[typeName].solutions[solutionName] = {
                        totalUnits: 0,
                        totalEconomy: 0,
                        totalEconomyWeighted: 0
                    };
                }
                
                kpis[typeName].solutions[solutionName].totalUnits += amount;
                kpis[typeName].solutions[solutionName].totalEconomyWeighted += economy * amount;
            });
            
            // Calcular médias
            Object.keys(kpis).forEach(typeName => {
                const typeKpi = kpis[typeName];
                typeKpi.averageEconomy = typeKpi.totalUnits > 0 
                    ? (typeKpi.totalEconomyWeighted / typeKpi.totalUnits).toFixed(2)
                    : '0.00';
                
                // Calcular médias por solução
                Object.keys(typeKpi.solutions).forEach(solutionName => {
                    const solutionKpi = typeKpi.solutions[solutionName];
                    solutionKpi.averageEconomy = solutionKpi.totalUnits > 0
                        ? (solutionKpi.totalEconomyWeighted / solutionKpi.totalUnits).toFixed(2)
                        : '0.00';
                });
            });
            
            return kpis;
        },
        overallKpis() {
            let totalUnits = 0;
            let totalEconomyWeighted = 0;
            let totalSolutions = 0;
            
            this.filteredSolutionList.forEach(item => {
                const baseAmount = Number(item.amountSolution) || 0;
                const localMultiplier = this.getLocalMultiplier(item.local);
                const amount = baseAmount * localMultiplier;
                const economy = Number(item.economy) || 0;
                totalUnits += amount;
                totalEconomyWeighted += economy * amount;
                totalSolutions += 1;
            });
            
            return {
                totalUnits,
                averageEconomy: totalUnits > 0 ? (totalEconomyWeighted / totalUnits).toFixed(2) : '0.00',
                totalSolutions
            };
        }
    },

    methods: {
        create() {
            this.isAdd = true
            this.index = -1
            this.solution = newSolution()
            // Marca novas soluções como modificadas
            this.solution.isModified = true
            this.dialog = true
            this.selectedItems = []
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.$refs.testSolutionForm) {
                        this.$refs.testSolutionForm.resetValidation()
                        const formElement = this.$refs.testSolutionForm.$el
                        formElement.scrollIntoView({behavior: 'smooth', block: 'start' })
                    }
                }, 100)
            })
        },
        loadingForAction(actionType) {
            return this.loadingForActions && this.loadingForActions.action === actionType;
        },
        isDisabled(actionType, item) {
            const currentIndex = this.calculatedIndex(item);
            return (this.index !== -1) && this.loadingForActions &&
                (this.loadingForActions.index !== currentIndex || this.loadingForActions.action === actionType);
        },
        calculatedIndex(item) {
            // Prioridade 1: id do Firestore
            if (item.id) {
                return this.solutionList.findIndex(s => s.id === item.id)
            }

            // Prioridade 2: busca por referência direta em solutionList
            // (funciona quando item vem do modo lista, que não passa por spread)
            const byRef = this.solutionList.indexOf(item)
            if (byRef !== -1) {
                return byRef
            }

            // Prioridade 3: item vem do modo agrupado (passou por { ...item } no parseSolutionList)
            // Usa o solution_list_map que já guarda o solutionIndex
            const mapEntry = this.solution_list_map.find(entry => {
                const local = this.sanitizeName(item.local)
                const subLocal = this.sanitizeName(item.sub_local)
                if (entry.local !== local || entry.sub_local !== subLocal) return false

                const groupedItem = this.groupedList
                    .find(g => g.local === local)
                    ?.sub_locals.find(s => s.sub_local === subLocal)
                    ?.items[entry.index]

                return groupedItem === item  // referência do spread
            })
            if (mapEntry) {
                return mapEntry.solutionIndex
            }

            // Prioridade 4 (Fallback Final): Se referência e ID falharem, acha por "Deep Match" tolerante
            const fallbackIndex = this.solutionList.findIndex(solution => 
                this.sanitizeName(solution.local) === this.sanitizeName(item.local) &&
                this.sanitizeName(solution.sub_local) === this.sanitizeName(item.sub_local) &&
                solution.solution === item.solution &&
                solution.type === item.type &&
                Number(solution.amountSolution) === Number(item.amountSolution) &&
                Number(solution.flowRateBefore) === Number(item.flowRateBefore)
            );

            return fallbackIndex !== -1 ? fallbackIndex : -1;
        },
        checkIfHasImg(item) {
          return !!((item.path_before_solution || item.path_after_solution) || (item.file_before_solution || item.file_after_solution));
        },
        async getImages(data){
            try {
                // Carrega as imagens em paralelo
                const [beforeImage, afterImage] = await Promise.all([
                    data.path_before_solution ? DiagnosticStorage.downloadImg(data.path_before_solution) : null,
                    data.path_after_solution ? DiagnosticStorage.downloadImg(data.path_after_solution) : null
                ]);

                // Atualiza os dados apenas se as imagens foram carregadas com sucesso
                if (beforeImage) data.file_before_solution = beforeImage;
                if (afterImage) data.file_after_solution = afterImage;

            } catch (error) {
                console.error('SolutionList - Erro ao carregar imagens:', error);
                // Mantém os paths mesmo se houver erro no download
                data.file_before_solution = null;
                data.file_after_solution = null;
            }
        },
        handleImageChange(type, file) {
            if (type === 'before') {
                if (!file) {
                    this.solution.path_before_solution = null;
                    this.solution.file_before_solution = null;
                } else {
                    this.solution.path_before_solution = null;
                    this.solution.file_before_solution = file;
                }
            } else {
                if (!file) {
                    this.solution.path_after_solution = null;
                    this.solution.file_after_solution = null;
                } else {
                    this.solution.path_after_solution = null;
                    this.solution.file_after_solution = file;
                }
            }
        },
        async edit(item) {
            this.isAdd = false
            // Usa o mesmo cálculo robusto de índice usado no delete,
            // para garantir que estamos editando o item original da lista.
            this.index = this.calculatedIndex(item)
            
            // Se por algum motivo não encontrar, mantém o comportamento atual (adiciona como novo),
            // mas em condições normais o índice deve ser >= 0.
            if (this.index === -1) {
                this.index = this.list.findIndex(solution => solution === item)
            }

            this.loadingForActions = { index: this.index, action: 'edit' };
            
            this.solution = cloneDeep({...item, isModified: true})
            
            this.loadingImage = true
            await this.getImages(this.solution)
            this.loadingImage = false
            this.dialog = true

            this.loadingForActions = null;
        },
        async save(continueAdding) {
            if (!this.$refs.testSolutionForm.validate()) return
            this.loading = true
            
            // Marca a solução como modificada sempre que for adicionada ou editada
            this.solution.isModified = true;
            
            this.add(cloneDeep(this.solution), this.index)
            this.solution = newSolution()
            this.selectedItems = []
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.$refs.testSolutionForm) {
                        this.$refs.testSolutionForm.resetValidation()
                        const formElement = this.$refs.testSolutionForm.$el
                        formElement.scrollIntoView({behavior: 'smooth', block: 'start' })
                    }
                }, 100)
            })
            this.loading = false
            this.dialog = continueAdding
        },
        closeDialog() {
            this.dialog = false
        },
        optionTypeSelect(type_id) {
            return this.solutionsData.filter(({pointId}) => pointId == type_id)
        },
        getSolutionsForType(typeId) {
            if (!typeId) return [];
            return this.optionTypeSelect(typeId);
        },
        async listSolutions(){
            this.solutionsData =  await SolutionsServices.GetSolutions()
        },
        async listSolutionsToFranchisees(){
            this.solutionsData =  await SolutionsServices.GetSolutionsToFranchisee()
        },
        async listPoints(){
            let pointIds = this.solutionsData.map((item) => item.type == 'Produto' ? item.pointId : null).filter((item) => item !== null && item !== undefined)
            let response =  await SolutionsPoint.GetSolutionsPointByIds(pointIds)
            this.pointsData = Object.values(response)
        },
        calculateEconomy() {
            let flowRateBefore = Number(this.solution.flowRateBefore)
            let flowRateAfter = Number(this.solution.flowRateAfter)
            if (flowRateBefore == 0 || flowRateAfter > flowRateBefore){
                this.solution.economy = 0
                return 0  
            } 
            let economy = 100 - ((flowRateAfter / flowRateBefore) * 100)
            economy = parseFloat(Math.abs(economy).toFixed(2))
            this.solution.economy = economy
        },
        verifyPipingType() {
            let type = this.solution.type
            let pipingType = this.solution.pipingType
            if (type !== PIPING_POINT_ID) {
                this.solution.pipingType = ""
            } else if(pipingType === "") {
                this.solution.pipingType = "PVC"
            }
        },
        verifyFlowRateType() {
            let flowRateType = this.solution.flowRateType
            if (flowRateType === "") {
                this.solution.flowRateType = "REAL"
            }
        },
        convertNameType(pointId){
            const type = this.pointsData.filter(({id}) => id == pointId)
            return type.length > 0 ? type[0].name : "Não Existe"
        },
        convertSolutionName(solutionId){
            const solutionFilter = this.solutionsData.filter(({id}) => id == solutionId)
            return solutionFilter.length > 0? solutionFilter[0].solution : "Não Existe"
        },
        async confirmDeleteSolution(item) {
            const idx = this.calculatedIndex(item)
            if (idx === -1) {
                showErrorSnackBar("Erro ao encontrar o item para deletar")
                return
            }
            showDeleteDialogAlert(`Deseja excluir esse item?`, async () => {
                this.remove(this.list[idx])  // ← referência real
                this.selectedItems = this.selectedItems.filter(s => s !== item)
                this.$nextTick(() => this.parseSolutionList())
            })
        },
        changeColorIconListImg(solution) {
            if(solution.imgNameList && solution.imgNameList.length > 0)return "primary"
            return ""
        },
        hasBeforeImage(item) {
            return !!(item.path_before_solution || item.file_before_solution);
        },
        hasAfterImage(item) {
            return !!(item.path_after_solution || item.file_after_solution);
        },
        deleteLot() {
            if (this.selectedItems.length === 0) return
            showDeleteDialogAlert(`Deseja excluir ${this.selectedItems.length} item(ns)?`, () => {
                this.selectedItems.forEach(item => {
                    const idx = this.calculatedIndex(item)
                    if (idx === -1) return
                    this.remove(this.list[idx])
                })
                this.selectedItems = []
                this.$nextTick(() => this.parseSolutionList())
            })
        },
        toggleSelectAll() {
            if (this.allSelected) {
                this.selectedItems = [];
                this.selectAllGlobal = false;
            } else {
                this.selectedItems = [...this.filteredSolutionList];
                this.selectAllGlobal = true;
            }
        },
        toggleSelectAllGlobal(status) {
            if (status) {
                this.selectedItems = [...this.filteredSolutionList];
            } else {
                this.selectedItems = [];
            }
        },
        allSelectedInGroup(items) {
            if (!items || items.length === 0) return false;
            return items.every(item => this.selectedItems.includes(item));
        },
        someSelectedInGroup(items) {
            if (!items || items.length === 0) return false;
            return items.some(item => this.selectedItems.includes(item));
        },
        toggleSelectAllInGroup(items) {
            if (!items || items.length === 0) return;
            const allSelected = this.allSelectedInGroup(items);
            if (allSelected) {
                // Remove todos os itens do grupo
                items.forEach(item => {
                    const index = this.selectedItems.indexOf(item);
                    if (index > -1) {
                        this.selectedItems.splice(index, 1);
                    }
                });
            } else {
                // Adiciona todos os itens do grupo
                items.forEach(item => {
                    if (!this.selectedItems.includes(item)) {
                        this.selectedItems.push(item);
                    }
                });
            }
            // Atualiza o switch global
            this.selectAllGlobal = this.filteredSolutionList.length > 0 && this.selectedItems.length === this.filteredSolutionList.length;
        },
        toggleItemSelection(item) {
            const idx = this.selectedItems.indexOf(item);
            if (idx === -1) {
                this.selectedItems.push(item);
            } else {
                this.selectedItems.splice(idx, 1);
            }
            // Atualiza o switch global
            this.$nextTick(() => {
                this.selectAllGlobal = this.filteredSolutionList.length > 0 && this.selectedItems.length === this.filteredSolutionList.length;
            });
        },
        changeLocal(local) {
            if (local && local.text) {
                this.solution.local = local.text
                
                // Sempre que o local da solução for definido/alterado,
                // atualiza o total de unidades deste ponto com base no multiplicador do local.
                const multiplier = this.getLocalMultiplier(local.text);
                this.solution.localTotalUnits = multiplier;
            }
        },
        changeSublocal(sublocal) {
            if (sublocal && sublocal.text) {
                this.solution.sub_local = sublocal.text
            }
        },
        // Métodos de agrupamento
        sanitizeName(name) {
            if (!name) return ""
            return Utils.defaultUpper(Utils.defaultSpace(Utils.clearAccents(name)))
        },
        findItemIndex(items, key, name) {
            return items.findIndex((item) => item[key] == name)
        },
        /**
         * Gera uma chave normalizada para o local, reutilizando a sanitização já existente.
         * Essa chave será usada no mapa de multiplicadores por local.
         */
        getLocalKey(localName) {
            if (!localName) return "";
            return this.sanitizeName(localName);
        },
        /**
         * Retorna o multiplicador configurado para um local.
         * Caso não exista configuração, o padrão é 1 (sem multiplicação).
         */
        getLocalMultiplier(localName) {
            const key = this.getLocalKey(localName);
            const value = this.localMultipliers[key];
            if (!value || value <= 0) return 1;
            return value;
        },
        /**
         * Reconstroi o mapa de multiplicadores de acordo com as soluções atuais.
         * Útil ao reabrir o diagnóstico, quando as soluções já vêm do backend
         * com o campo localTotalUnits preenchido.
         */
        syncLocalMultipliersFromSolutions() {
            const newMap = {};
            
            if (Array.isArray(this.solutionList)) {
                this.solutionList.forEach(solution => {
                    const key = this.getLocalKey(solution.local);
                    if (!key) return;
                    
                    const units = Number(solution.localTotalUnits || 1);
                    if (!newMap[key] || units > newMap[key]) {
                        newMap[key] = units > 0 ? units : 1;
                    }
                });
            }
            
            this.localMultipliers = newMap;
        },
        /**
         * Abre o modal para configurar o multiplicador de um local específico.
         */
        openLocalMultiplierDialog(localName) {
            const key = this.getLocalKey(localName);
            const current = this.getLocalMultiplier(localName);
            this.localMultiplierForm.localName = localName;
            this.localMultiplierForm.localKey = key;
            this.localMultiplierForm.totalUnits = current;
            this.localMultiplierDialog = true;
        },
        /**
         * Salva o multiplicador definido para o local atual.
         * Neste momento o efeito é apenas em memória; KPIs/relatórios serão ajustados em passos posteriores.
         */
        saveLocalMultiplier() {
            const total = Number(this.localMultiplierForm.totalUnits) || 1;
            const sanitized = total < 1 ? 1 : total;
            if (!this.localMultiplierForm.localKey) return;
            this.$set(this.localMultipliers, this.localMultiplierForm.localKey, sanitized);
            
            // Atualiza todas as soluções deste local com a nova quantidade total de unidades
            this.solutionList.forEach(solution => {
                const solutionKey = this.getLocalKey(solution.local);
                if (solutionKey === this.localMultiplierForm.localKey) {
                    // Garante reatividade ao adicionar o campo se ainda não existir
                    if (typeof solution.localTotalUnits === 'undefined') {
                        this.$set(solution, 'localTotalUnits', sanitized);
                    } else {
                        solution.localTotalUnits = sanitized;
                    }
                    // Marca a solução como modificada para garantir que será salva no backend
                    this.$set(solution, 'isModified', true);
                }
            });
            
            this.localMultiplierDialog = false;
        },
        parseSolutionList() {
            let _list = []
            this.locals = []
            this.sub_locals_by_local = {}
            this.values_sub_locals_by_local = {}
            this.solution_list_map = []
            
            this.filteredSolutionList.forEach((item, solutionIndex) => {
                let local = this.sanitizeName(item.local)
                let local_index = this.findItemIndex(_list, 'local', local)
                let sub_local = this.sanitizeName(item.sub_local)
                let sub_local_index = -1
                
                if (local_index < 0) {
                    _list.push({
                        local,
                        isViewLocal: true,
                        sub_locals: []
                    })
                    local_index = _list.length - 1
                    _list[local_index].sub_locals.push({
                        sub_local,
                        isViewSublocal: true,
                        items: []
                    })
                    sub_local_index = _list[local_index].sub_locals.length - 1
                } else {
                    sub_local_index = this.findItemIndex(_list[local_index].sub_locals, 'sub_local', sub_local)
                    if (sub_local_index < 0) {
                        _list[local_index].sub_locals.push({
                            sub_local,
                            isViewSublocal: true,
                            items: []
                        })
                        sub_local_index = _list[local_index].sub_locals.length - 1
                    }
                }
                
                _list[local_index].sub_locals[sub_local_index].items.push({
                    ...item,
                    local,
                    sub_local,
                })
                
                this.solution_list_map.push({
                    local,
                    sub_local,
                    index: _list[local_index].sub_locals[sub_local_index].items.length - 1,
                    solutionIndex,
                })

                if (!this.locals.includes(local)) {
                    this.locals.push(local)
                    this.sub_locals_by_local[local] = []
                    this.values_sub_locals_by_local[local] = []
                }
                if (!this.sub_locals_by_local[local].includes(sub_local)) {
                    this.sub_locals_by_local[local].push(sub_local)
                }
            })
            
            this.groupedList = _list
        },
        showLocals(locals = []) {
            if (locals.length > 0) {
                this.groupedList = this.groupedList.map((item) => {
                    if (locals.includes(item.local)) {
                        return {
                            ...item,
                            isViewLocal: true
                        }
                    } else {
                        return {
                            ...item,
                            isViewLocal: false
                        }
                    }
                })
            } else {
                this.groupedList = this.groupedList.map((item) => {
                    return {
                        ...item,
                        isViewLocal: true
                    }
                })
            }
        },
        showSublocals(local, sublocals = []) {
            if (sublocals.length > 0) {
                this.groupedList = this.groupedList.map((localItem) => {
                    let _localItem = localItem
                    if (local === _localItem.local) {
                        _localItem.sub_locals = _localItem.sub_locals.map((sublocalItem) => {
                            if (sublocals.includes(sublocalItem.sub_local)) {
                                return {
                                    ...sublocalItem,
                                    isViewSublocal: true
                                }
                            } else {
                                return {
                                    ...sublocalItem,
                                    isViewSublocal: false
                                }
                            }
                        })
                    }
                    return _localItem
                })
            } else {
                this.groupedList = this.groupedList.map((localItem) => {
                    let _localItem = localItem
                    if (local === _localItem.local) {
                        _localItem.sub_locals = _localItem.sub_locals.map((sublocalItem) => {
                            return {
                                ...sublocalItem,
                                isViewSublocal: true
                            }
                        })
                    }
                    return _localItem
                })
            }
        },
        changeSubLocal(local) {
            this.showSublocals(local, this.values_sub_locals_by_local[local])
        },
        async expandAll(status) {
            if (status) {
                await this.openAllLocals()
            } else {
                this.closeAllLocals()
            }
        },
        async openAllLocals() {
            this.localPanels = this.groupedList.map((_, index) => index)
            for (let i = 0; i < this.groupedList.length; i++) {
                this.localPanels = this.groupedList.slice(0, i + 1).map((_, index) => index)
                await new Promise(resolve => setTimeout(resolve, 50))
            }
        },
        closeAllLocals() {
            this.localPanels = []
        },
        async expandAllSublocals(localIndex, status) {
            if (status) {
                this.openAllSublocals(localIndex)
            } else {
                this.closeAllSublocals(localIndex)
            }
        },
        async openAllSublocals(localIndex) {
            for (let i = 0; i < this.groupedList[localIndex].sub_locals.length; i++) {
                this.$set(this.sublocalPanels, localIndex, this.groupedList[localIndex].sub_locals.slice(0, i + 1).map((_, index) => index))
                await new Promise(resolve => setTimeout(resolve, 50))
            }
        },
        closeAllSublocals(localIndex) {
            this.$set(this.sublocalPanels, localIndex, [])
        },
        getModifiedCountByLocal(local) {
            if (!local) return 0;
            const sanitizedLocal = this.sanitizeName(local);
            const localGroup = this.groupedList.find(item => this.sanitizeName(item.local) === sanitizedLocal);
            if (!localGroup) return 0;
            
            let count = 0;
            localGroup.sub_locals.forEach(subLocalGroup => {
                count += subLocalGroup.items.filter(item => item.isModified).length;
            });
            return count;
        },
        getModifiedCountBySublocal(local, sub_local) {
            if (!local || !sub_local) return 0;
            const sanitizedLocal = this.sanitizeName(local);
            const sanitizedSublocal = this.sanitizeName(sub_local);
            const localGroup = this.groupedList.find(item => this.sanitizeName(item.local) === sanitizedLocal);
            if (!localGroup) return 0;
            
            const subLocalGroup = localGroup.sub_locals.find(sub => this.sanitizeName(sub.sub_local) === sanitizedSublocal);
            if (!subLocalGroup) return 0;
            
            return subLocalGroup.items.filter(item => item.isModified).length;
        },
        toggleViewMode() {
            this.viewMode = this.viewMode === 'grouped' ? 'list' : 'grouped';
        },
        addRoom() {
            this.bulkCreateConfig.rooms.push({ 
                name: '', 
                quantity: 1,
                solutions: [
                    {
                        type: null,
                        solution: null,
                        amount: 1,
                        flowRateType: 'PROJETADA'
                    }
                ]
            });
        },
        removeRoom(index) {
            if (this.bulkCreateConfig.rooms.length > 1) {
                this.bulkCreateConfig.rooms.splice(index, 1);
            }
        },
        addSolution(roomIndex) {
            if (!this.bulkCreateConfig.rooms[roomIndex].solutions) {
                this.$set(this.bulkCreateConfig.rooms[roomIndex], 'solutions', []);
            }
            this.bulkCreateConfig.rooms[roomIndex].solutions.push({
                type: null,
                solution: null,
                amount: 1,
                flowRateType: 'PROJETADA',
                flowRateBefore: '',
                flowRateAfter: ''
            });
        },
        removeSolution(roomIndex, solutionIndex) {
            if (this.bulkCreateConfig.rooms[roomIndex].solutions.length > 1) {
                this.bulkCreateConfig.rooms[roomIndex].solutions.splice(solutionIndex, 1);
            }
        },
        generateBulkSolutions() {
            if (!this.$refs.bulkCreateForm.validate()) {
                return;
            }

            this.bulkCreateLoading = true;

            try {
                const solutions = [];
                const localName = this.bulkCreateConfig.localName.trim();
                const localCount = Number(this.bulkCreateConfig.localCount) || 0;

                // Gera todas as combinações
                for (let localIndex = 1; localIndex <= localCount; localIndex++) {
                    const local = `${localName} ${localIndex}`;
                    
                    // Para cada ambiente definido
                    this.bulkCreateConfig.rooms.forEach(room => {
                        const roomName = room.name.trim();
                        if (!roomName) return; // Pula se o nome do ambiente estiver vazio
                        
                        const roomQuantity = Number(room.quantity) || 1;
                        
                        // Cria a quantidade de ambientes especificada
                        for (let roomIndex = 1; roomIndex <= roomQuantity; roomIndex++) {
                            const roomLabel = roomQuantity > 1 ? `${roomName} ${roomIndex}` : roomName;
                            
                            // Para cada solução definida no ambiente
                            if (room.solutions && room.solutions.length > 0) {
                                room.solutions.forEach(solConfig => {
                                    if (!solConfig.type || !solConfig.solution) return; // Pula se não tiver tipo ou solução
                                    
                                    const solutionAmount = Number(solConfig.amount) || 1;
                                    
                                    // Cria a quantidade de soluções especificada
                                    for (let solIndex = 0; solIndex < solutionAmount; solIndex++) {
                                        const flowRateBefore = solConfig.flowRateBefore || "";
                                        const flowRateAfter = solConfig.flowRateAfter || "";
                                        
                                        // Calcula a economia se ambas as vazões estiverem preenchidas
                                        let economy = 0;
                                        if (flowRateBefore && flowRateAfter) {
                                            const before = Number(flowRateBefore);
                                            const after = Number(flowRateAfter);
                                            if (before > 0 && after <= before) {
                                                economy = 100 - ((after / before) * 100);
                                                economy = parseFloat(Math.abs(economy).toFixed(2));
                                            }
                                        }
                                        
                                        const solution = {
                                            ...newSolution(),
                                            local: local,
                                            sub_local: roomLabel,
                                            type: solConfig.type,
                                            solution: solConfig.solution,
                                            amountSolution: 1,
                                            flowRateBefore: flowRateBefore,
                                            flowRateAfter: flowRateAfter,
                                            flowRateType: solConfig.flowRateType || 'PROJETADA',
                                            economy: economy,
                                            comments: "",
                                            isModified: true, // Marca como modificada para indicar que precisa preencher
                                        };
                                        solutions.push(solution);
                                    }
                                });
                            }
                        }
                    });
                }

                // Adiciona todas as soluções de uma vez
                solutions.forEach(solution => {
                    this.add(cloneDeep(solution), -1);
                });

                // Fecha o dialog e mostra mensagem de sucesso
                this.bulkCreateDialog = false;
                showSuccessSnackBar(`Foram criadas ${solutions.length} soluções padrões com sucesso!`);
                
                // Limpa o formulário
                this.bulkCreateConfig = {
                    localName: '',
                    localCount: null,
                    rooms: [
                        { 
                            name: '', 
                            quantity: 1,
                            solutions: [
                                {
                                    type: null,
                                    solution: null,
                                    amount: 1,
                                    flowRateType: 'PROJETADA',
                                    flowRateBefore: '',
                                    flowRateAfter: ''
                                }
                            ]
                        }
                    ],
                };

            } catch (error) {
                console.error('Erro ao gerar soluções em massa:', error);
                showErrorSnackBar('Erro ao gerar soluções. Por favor, tente novamente.');
            } finally {
                this.bulkCreateLoading = false;
            }
        },
    },
    watch: {
        selectedItems(newVal) {
            this.showDeleteButton = newVal.length > 0
            this.showCheckListButtons = this.showAddButton || this.showDeleteButton
            // Atualiza o switch global baseado na seleção
            this.selectAllGlobal = this.filteredSolutionList.length > 0 && newVal.length === this.filteredSolutionList.length;
        },
        showAddButton(newVal) {
            this.showCheckListButtons = newVal || this.showDeleteButton
        },
        showDeleteButton(newVal) {
            this.showCheckListButtons = this.showAddButton || newVal
        },
        showCheckListButtons(newVal) {
            this.$nextTick(() => {
                var item = document.getElementById('itemAnimado');
                if (!item) return;
                if (newVal) {
                    item.classList.remove('item-escondido');
                    item.classList.add('item-visivel');
                } else {
                    item.classList.remove('item-visivel');
                    item.classList.add('item-escondido');
                }
            });
        },
        dialog(newValue) {
            if (!newValue) {
                this.listImgs = [];
                this.editedItem = {};
                this.deleteImgFile = {};
                this.rawFiles = [];
                this.selectedItems = []
            }
        },
        list:{
            deep: true, 
            handler(newValue){
                this.solutionList = newValue
                this.selectedItems = this.selectedItems.filter(item => newValue.includes(item))
                // Ao receber a lista do backend, reconstrói os multiplicadores a partir de localTotalUnits
                this.syncLocalMultipliersFromSolutions()
                this.parseSolutionList()
            }
        },
        values_locals(newVal) {
            if (newVal) {
                this.showLocals(newVal)
            }
        },
        groupedList(newVal) {
            if (newVal) {
                for (let i = 0; i < this.groupedList.length; i++) {
                    if (!this.sublocalPanels.hasOwnProperty(i)) {
                        this.$set(this.sublocalPanels, i, [])
                        this.$set(this.sublocal_expand_all, i, false)
                    }
                }
            }
        },
        'solution.flowRateBefore': function (newValue) {
            this.calculateEconomy()
        },
        'solution.flowRateAfter': function (newValue) {
            this.calculateEconomy()
        },
        'solution.type': function (newValue) {
            this.verifyPipingType()
        },
        'solution.flowRateType': function () {
            this.verifyFlowRateType()
        },
    },

    async created() {
        if (this.getCurrentUser.data.rank === "Super Admin" || this.getCurrentUser.data.rank === "Admin") { 
            await this.listSolutions();
        }else if(this.isFranchisee){
            await this.listSolutionsToFranchisees();
        }
        await this.listPoints()
        // Garante que, ao abrir o diagnóstico, os multiplicadores sejam carregados
        // a partir das soluções já salvas (campo localTotalUnits)
        this.syncLocalMultipliersFromSolutions()
        this.parseSolutionList()
    },
    mounted() {
        this.interval = setInterval(
            () => {
                const el = document.querySelector("#solution-list")
                if (!el) return;
                const { top } = el.getBoundingClientRect();
                if (top <= -35) {
                    this.showAddButton = true
                } else {
                    this.showAddButton = false
                }
                this.showCheckListButtons = this.showAddButton || this.showDeleteButton
            },
            100
        )
    },
    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval)
            this.interval = null
        }
    }

};
</script>
  
<style scoped>
.checkbox-large {
  transform: scale(1.5); /* Aumenta 1.5x, ajuste conforme necessário */
  margin-right: 8px;
  cursor: pointer;
}
.item-escondido {
    transform: translateY(94vh);
    /* Posiciona o item fora da tela na parte inferior */
    transition: transform 0.5s ease-out;
    /* Suaviza a transição */
}

.item-visivel {
    transform: translateY(0);
    /* Move o item para sua posição final */
}
</style>